// Lazy load GeoJSON only when needed (saves ~3.6MB from initial bundle)
let cachedGeoJson = null;

const loadGeoJson = async () => {
  if (cachedGeoJson) return cachedGeoJson;
  
  // Dynamic import - only loads when Map component is used
  const module = await import('./locations.geojson?raw');
  cachedGeoJson = JSON.parse(module.default);
  return cachedGeoJson;
};

export const getLocationsData = async () => {
  const geoJsonData = await loadGeoJson();
  return geoJsonData.features.map(feature => ({
    id: feature.properties.id,
    text: feature.properties.text,
    type: feature.properties.type,
    latitude: feature.geometry.coordinates[1],
    longitude: feature.geometry.coordinates[0]
  }));
};

export const getGeoJsonData = async () => {
  return await loadGeoJson();
};